
export class JackpotData {

     // private type: string;
     // private biggestWinWinner: string;
     // private biggestWinAmount: number;
     // private biggestWinDate: string;
     // private totalWin: number;
     // private lastWinWinner: string;
     // private lastwinAmount: number;
     // private lastWinDate: string;
     private currentValue: number;




     constructor() {

          // this.type;
          // this.biggestWinWinner;
          // this.biggestWinAmount;
          // this.biggestWinDate;
          // this.totalWin;
          // this.lastWinWinner;
          // this.lastwinAmount;
          // this.lastWinDate;
          this.currentValue = 10;

     }

     // private setType = (jackpotdata: string): void => {
     //      this.type = jackpotdata;

     // }
     // private setBiggestWinID = (jackpotdata: string): void => {
     //      this.biggestWinWinner = jackpotdata;
     // }
     // private setBiggestWinAmount = (jackpotdata: number): void => {
     //      this.biggestWinAmount = jackpotdata;

     // }
     // private setBiggestWinDate = (jackpotdata: string): void => {
     //      this.biggestWinDate = jackpotdata;
     // }
     // private setTotalWin = (jackpotdata: number): void => {
     //      this.totalWin = jackpotdata;

     // }
     // private setLasttWinID = (jackpotdata: string): void => {
     //      this.lastWinWinner = jackpotdata;
     // }
     // private setLasttWinDate = (jackpotdata: string): void => {
     //      this.lastWinDate = jackpotdata;

     // }
     // private setLasttWinAmount = (jackpotdata: number): void => {
     //      this.lastwinAmount = jackpotdata;
     // }


     // public setData = (jackpotdata: Array<string | number>): void => {
     //      this.setType(jackpotdata[0] as string)

     //      this.setBiggestWinID(jackpotdata[1] as string)


     //      this.setBiggestWinAmount(jackpotdata[2] as number)

     //      this.setBiggestWinDate(jackpotdata[3] as string)

     //      this.setTotalWin(jackpotdata[4] as number)

     //      this.setLasttWinID(jackpotdata[5] as string)

     //      this.setLasttWinDate(jackpotdata[6] as string)

     //      this.setLasttWinAmount(jackpotdata[7] as number)


     // }


     // public setJackpotData = (data: any): void => {
     //      this.setType(data.type as string)

     //      // this.setBiggestWinID(data.biggestWim as string)


     //      this.setBiggestWinAmount(data.biggestWin as number)

     //      this.setBiggestWinDate(data.biggestWinDate as string)

     //      this.setTotalWin(data.totalWins as number)

     //      this.setLasttWinID(data.lastWinner as string)

     //      this.setLasttWinDate(data.lastWinDate as string)

     //      this.setLasttWinAmount(data.lastWinAmount as number)


     // }





     public setCurrent = (newValue: number): void => {
          this.currentValue = newValue;
     }
     public getCurrent = (): number => {
          return this.currentValue;
     }

}

